import publicity from '@/locales/es/publicity/publicity.locales';

export default {
    ...publicity,
};
